<template>
  <div class="calcFormsForm">
    <div v-if="loading">
      <v-progress-circular
        :size="20"
        color="primary"
        class="mr-2"
        indeterminate
      ></v-progress-circular>
      Loading...
    </div>
    <div v-else-if="derivationItem">
      <v-form ref="derivationForm" v-model="isFormValid" lazy-validation>
        <div>
          <v-text-field
            v-model="derivationItem.Name"
            label="Name"
            :rules="rules"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
        <div>
          <v-select
            v-model="derivationItem.Type"
            label="Type"
            :items="derivationTypeList"
            :rules="rules"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-select>
        </div>
        <div>
          <v-select
            label="Form"
            v-model="derivationItem.TableName"
            :items="formList"
            :rules="rules"
            :loading="areFormsLoading"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-select>
        </div>
        <div>
          <v-select
            label="Field"
            v-model="derivationItem.Fieldname"
            :items="fieldList"
            :loading="areFieldsLoading"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-select>
        </div>
        <div>
          <v-select
            label="Action"
            v-model="derivationItem.Action"
            :items="actionList"
            :rules="rules"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-select>
        </div>
        <div>
          <v-text-field
            v-model="derivationItem.Calculation"
            label="Calculation item"
            append-icon="mdi-arrow-down-bold-box"
            :readonly="!showFormButtons"
            dense
            outlined
            @click:append="openCalculationSelection('CalculationItem')"
          ></v-text-field>
        </div>
        <div>
          <v-text-field
            v-model="derivationItem.Message"
            label="Message"
            :rules="rules"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
      </v-form>

      <div v-if="showFormButtons" class="formFooter">
        <div class="btnContainer">
          <v-btn v-if="derivationId" color="error" outlined @click="onDelete" class="mr-4">
            Delete
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="onExport" class="mr-4"> Export </v-btn>
          <v-btn color="primary" outlined @click="onCancel" class="mr-4"> Cancel </v-btn>
          <v-btn color="primary" depressed @click="onSave"> Save </v-btn>
        </div>
      </div>
    </div>
    <div v-else>
      <v-alert type="info" outlined dense>No info found for this element</v-alert>
    </div>
    <Dialog ref="confirmationDialog" v-model="dialog"></Dialog>
    <CalculationSelection ref="calculationSelection" :levelId="planId" @select="onSelect" />
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';
import CalculationSelection from './Popups/CalculationSelection.vue';

export default {
  name: 'DerivationForm',
  components: {
    Dialog,
    CalculationSelection,
  },
  props: {
    derivationId: { type: Number },
    planId: { type: Number },
    type: { type: String },
  },

  data() {
    return {
      loading: false,
      areFormsLoading: false,
      areFieldsLoading: false,

      isFormValid: false,
      dialog: false,
      derivationItem: null,
      rules: [(value) => !!value || 'Required.'],

      derivationTypeList: ['Derivation', 'Message'],
      formList: [],
      fieldList: [],
    };
  },

  computed: {
    levelsList() {
      return [
        { text: 'System', value: 0 },
        { text: 'Plan', value: this.currentPlanId },
      ];
    },
    actionList() {
      if (this.derivationItem.Type === 'Derivation') return ['Update'];
      return ['Abort', 'Warning'];
    },
    formName() {
      if (this.derivationItem) return this.derivationItem.TableName;
      return null;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },

  watch: {
    derivationId: function () {
      if (this.derivationId) this.getForm();
      else this.createNewForm();
    },
    formName() {
      if (this.formName) this.getFieldsList();
    },
  },

  created() {
    if (this.derivationId) this.getForm();
    else this.createNewForm();

    this.getFormsList();
  },

  methods: {
    createNewForm() {
      this.derivationItem = {
        Type: '',
        DerivationId: 0,
        Name: '',
        PlanId: this.planId,
        GroupId: 0,
        TableName: '',
        Fieldname: '',
        Action: '',
        Message: '',
        Calculation: '',
      };
    },

    onCancel() {
      if (this.derivationId) this.getForm();
      else this.createNewForm();
    },

    onSave() {
      const isFormValid = this.$refs.derivationForm.validate();
      if (isFormValid) this.saveData();
    },

    async onExport() {
      try {
       var data = {PlanId:this.planId,GroupId:this.GroupId,CalcType:this.type,Calculation:[this.derivationId]};
       const response = await this.$api({
          method: 'POST',
          url: '/Calculation/ExportCalculations',
          data:data,
          responseType: 'blob',
        });

        if (!response.data) {
          console.log('no response');
          const msg = 'Unable to get download path';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: 'text/xml',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        console.log('response'+url);
        link.setAttribute('download', "calculations.xml");
        document.body.appendChild(link);
        link.click();
      }
      catch(err) {
        console.log(err);
      }
    },

    openCalculationSelection() {
      if (!this.showFormButtons) return;
      this.$refs.calculationSelection.open();
    },

    onSelect(val) {
      this.derivationItem.Calculation = val;
    },

    async onDelete() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.deleteForm();
      } catch (err) {
        console.log(err);
      }
    },

    async getForm() {
      this.derivationItem = null;
      this.loading = true;
      try {
        let response = await this.$api.get('/Derivation/GetDerivationById?id=' + this.derivationId);

        if (!response.data) {
          const msg = 'Unable to load derivation item with id ' + this.derivationId;
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        var data = response.data;
        this.derivationItem = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async saveData() {
      this.updateForm();
    },

    async updateForm() {
      try {
        let response = await this.$api.post('/Derivation/UpdateDerivation', this.derivationItem);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Derivation was saved',
        });
        if (this.derivationItem.DerivationId === 0) {
          this.$emit('reloadList', 'update', response.data.Value);
        } else {
          this.$emit('reloadList', 'update');
          this.getForm();
        }
      } catch (err) {
        console.error(err);
      }
    },

    async deleteForm() {
      try {
        await this.$api.delete('/Derivation/DeleteDerivation?id=' + this.derivationId);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Element is deleted',
        });
        this.$emit('reloadList', 'delete');
      } catch (err) {
        console.error(err);
      }
    },

    async getFormsList() {
      this.areFormsLoading = true;
      try {
        let response = await this.$api.get('/DataDictionary/GetFormList');

        if (!response.data || !response.data.length) {
          const msg = 'Unable to load forms list';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.formList = response.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.areFormsLoading = false;
      }
    },

    async getFieldsList() {
      this.areFieldsLoading = true;
      try {
        let response = await this.$api.get(
          `/DataDictionary/GetFieldList?formName=${this.formName}&planId=${this.planId}`
        );
        if (response.data.length) this.fieldList = response.data.map((item) => item.ShortName);
      } catch (err) {
        console.error(err);
      } finally {
        this.areFieldsLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
